import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { captureException } from '@sentry/react';
import { fetchIntakeForm, fetchVisit } from '@api';
import { useApplicationStore } from '@data';
import { IntakeForm } from '@qmd-types/intakeForms';
import { refetchAndSetPatientProfile } from '@router/loaders/utils';
import {
  BOOKING_CONFIRMATION_ROUTE_PATHNAME,
  SERVICES_ROUTE_PATHNAME,
} from '@router/routes/routePathnames';

interface LoaderContext extends LoaderFunctionArgs {
  params: {
    id?: string;
  };
}

export async function intakeFormLoader({
  params,
}: LoaderContext): Promise<Response | IntakeForm> {
  const { patient } = useApplicationStore.getState();
  const { patientProfile, setVisitDetail, visitDetail } = patient;

  if (!patientProfile) {
    try {
      await refetchAndSetPatientProfile();
    } catch {
      // TODO: Handle error https://quick-md.atlassian.net/browse/QMD-1388
      return redirect(SERVICES_ROUTE_PATHNAME);
    }
  }

  if (!params.id) {
    return redirect(BOOKING_CONFIRMATION_ROUTE_PATHNAME);
  }

  try {
    const intakeForm = await fetchIntakeForm(params.id);
    const { visitId } = intakeForm;

    if (visitDetail?.visitId !== visitId) {
      const visit = await fetchVisit(visitId);
      setVisitDetail(visit);
    }

    return intakeForm;
  } catch (error) {
    // TODO: Handle error https://quick-md.atlassian.net/browse/QMD-1388
    captureException(error);
  }

  return redirect(BOOKING_CONFIRMATION_ROUTE_PATHNAME);
}
